import { render } from "./ValidacionTratamientoDatos.vue?vue&type=template&id=b64ead16"
import script from "./ValidacionTratamientoDatos.vue?vue&type=script&lang=js"
export * from "./ValidacionTratamientoDatos.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agentcloudALProd\\_work\\12\\s\\AEL.NominaElectronica.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__